import { createTheme } from "@mui/material/styles";

/** Motyw MUI aplikacji — wspólny dla aplikacji głównej (src/main.tsx) i aplikacji EBI (ebi/src/main.tsx). */
const muiTheme = createTheme({
  typography: {
    fontFamily: "Rubik",
  },
  palette: {
    primary: {
      light: "#6a57cb",
      main: "#5d49c7",
      dark: "#6a57cb",
      contrastText: "#fff",
    },
    secondary: {
      light: "#F1EBFB",
      main: "#e5dff9",
      dark: "#CDC7E0",
      contrastText: "#190064",
    },
    error: {
      light: "#BA1A1A",
      main: "#BA1A1A",
      dark: "#BA1A1A",
    },
  },
});

export default muiTheme;
